import React from 'react';
import { Card, CardContent, Grid, Typography, Box, Link } from '@mui/material';
import { ChangeCircleOutlined, AirplaneTicketOutlined, Check } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

import { connect } from 'react-redux';

const FinalFlexiCard = ({ checkoutInfo }) => {
  const { t } = useTranslation();

  const storedTermsUrl = typeof window !== 'undefined' && localStorage.getItem('flexiTermsUrl');
  const termsUrl = checkoutInfo?.user_product?.products?.[0]?.parameters?.flexible_rate?.terms_and_conditions_url
                  || storedTermsUrl;

  const infoItems = [
    {
      text: t('checkout.common.flexiInfoText1'),
      icon: <ChangeCircleOutlined color="primary" />
    },
    {
      text: t('checkout.common.flexiInfoText2'),
      icon: <AirplaneTicketOutlined color="primary" />
    },
    {
      text: t('checkout.common.flexiInfoText3'),
      icon: <ChangeCircleOutlined color="primary" />
    }
  ];

  const rows = [
    {
      text: t('checkout.common.flexiCardIncluded'),
      icon: <Check color="success" />
    },
    {
      text: t('checkout.common.flexiCardIncluded'),
      icon: <Check color="success" />
    },
    {
      text: t('checkout.common.flexiCardIncluded'),
      icon: <Check color="success" />
    }
  ];

  return (
    <Card className="final-flexi-card" style={{ marginTop: 16, borderRadius: 10 }}>
      <CardContent>
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          Tarifa Flexible
        </Typography>


        {infoItems.map((leftItem, index) => {
          const rightItem = rows[index];

          return (
            <Grid
              container
              key={index}
              alignItems="center"
              style={{
                backgroundColor: index === 0 || index === 2 ? 'whitesmoke' : 'inherit',
                padding: '8px 0'
              }}
            >
              <Grid
                item
                xs={12}
                sm={6}
                style={{ display: 'flex', alignItems: 'center', paddingLeft: 8 }}
              >
                <Box style={{ marginRight: 8 }}>{leftItem.icon}</Box>
                <Typography variant="body2">{leftItem.text}</Typography>
              </Grid>

              <Grid
                item
                xs={12}
                sm={6}
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  paddingRight: 8
                }}
              >
                <Box style={{ marginRight: 8 }}>{rightItem.icon}</Box>
                <Typography variant="body2" color="success.main">
                  {rightItem.text}
                </Typography>
              </Grid>
            </Grid>
          );
        })}

        <Grid container alignItems="center" justifyContent="space-between" style={{ marginTop: 16 }}>
          <Grid item>
            <Typography variant="caption" color="text.secondary">
              {t('checkout.common.additionalTermsAndConditions')}
            </Typography>
          </Grid>
          <Grid item>
          {termsUrl && (
            <Link
              href={termsUrl}
              target="_blank"
              underline="hover"
              style={{ cursor: 'pointer' }}
            >
              {t('checkout.common.flexiCardTerms')}
            </Link>
          )}
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default FinalFlexiCard;